export const apiEndpoints = {
    loginUrl:`user/auth/login`,
    signUrl:`admin/auth/signup`,
    forgetUrl :'user/auth/forgot_password',
    otpVerifyUrl : "user/auth/verify_otp",
    resendOtpUrl : "user/auth/resend_otp",
    changePasswordUrl : "user/auth/change_password",
    resetPasswordUrl : "user/auth/reset_password",
    profileUrl : "user/auth/details",
    commonContentUrl : "common/common_content",
    commonContentUpdateUrl : "admin/common/common_content",
    userGetUrl : "admin/user/list", 
    userDetailsUrl : "user/user/details", 
    userStatusUrl : "admin/user/status",
    userDashboardUrl : "/user/auth/details",
    hcGetUrl : "Hc/listing",
    hcDetailsUrl:"Hc/detail",
    hcAddDetailsUrl:"Hc/add_hc_details",
    hcUpdateDetailsUrl:"Hc/update_hc_details",
    getCompanyUrl:"company/listing",
    getCompanyDetailUrl:"company/detail",
    addCompanyUrl:"company/add_company_details",
    addDetailCompanyUrl:"company/add_employee_division",
    imageUploadUrl:"common/upload_file",
    happcoachGetUrl : "happcoach/listing",
    happcoachDetailsUrl:"happcoach/detail",
    happcoachAddDetailsUrl:"happcoach/add_happcoach_details",
    happcoachUpdateDetailsUrl:"happcoach/update_happcoach_details",
    cltGetUrl : "clt/listing",
    cltDetailsUrl:"happcoach/detail",
    cltAddDetailsUrl:"clt/add_clt_details",
    cltUpdateDetailsUrl:"clt/update_clt_details",
    updatePassword:"user/auth/change_password",
    updateAdmin:"user/auth/profile",
    getProfileData : "user/auth/details",
    getDashboardUrl : "admin/auth/dashboard_count",
    getCompanyListing : "company/listing_admin",
    addCompanyDivision : "company/add_division_details",
    updateCompanyStatus : "company/update_company_details",
    getDeptListUrl:"department/listing_department_division",
    companyDetailsGraphActiveUSersUrl:"dashboard/company_active_employee_count",
    companyDetailsGraphDrActionUrl:"dashboard/dr_action_count",
    companygetEmpByType:"user/auth/listing_company_users", 
    companygetEmpByEmpIdUrl:"user/auth/user_detail_by_id", 
    divisionEmpTypeCount: "user/auth/count_company_users",
    divisionDetailByIdUrl:"company/division_detail",
    settingsGetUrl:"common/setting_content",
    settingsUpdateUrl:"common/update_setting_content",
    getDashboardGraphUrl:"dashboard/compay_division_clt_happcoach_count",
    userActionUrl:"common/get_dropdown",
    userActionMessageUrl:"Hc/action_count_users_admin",
    updateDropdownActionUrl:"common/update_dropdown",
    updateUserAllowScreenUrl:"user/auth/profile",
    messageGetUrl:"user/auth/user_panel_list",
    deleteAccountUrl: "user/auth/delete_account",
    getNotificationUrl: "Hc/list_action_notif",
    getCommonHCList: "Hc/hc_list_by_type",
}